let savedRoleSelection = null;

export default context => {
    const id = context.getters.moduleId;
    const roleId =  `${id}_complaint-submission_role`;
    const allegationsId = `${id}_allegations_checklist`;
    const retaliationSelected = context.rootState[allegationsId].value.includes('ERAEIWR');
    const role = context.rootState[roleId].value;
    const processedOptions = context.rootState[roleId].options.map(opt => {
        if (opt.value !== 'worker') {
            opt.disabled = retaliationSelected ? 'true' : null;
        }
        return opt;
    });

    if (retaliationSelected) {
        if (role) {
            savedRoleSelection = role;
        }
        context.commit('setAttribute', {
            id: roleId,
            attribute: 'value',
            value: 'worker',
        }, { root: true });

    } else {
        context.commit('setAttribute', {
            id: roleId,
            attribute: 'value',
            value: savedRoleSelection,
        }, { root: true });

    }

    context.commit('setAttribute', {
        id,
        attribute: 'retaliationSelected',
        value: retaliationSelected,
    }, { root: true });

    context.commit('setAttribute', {
        id: roleId,
        attribute: 'options',
        value: processedOptions,
    }, { root: true });
    context.dispatch(`${id}/roleChange`, {
        targetId: roleId,
    }, { root: true });
};